<template>
	<div
		v-if="
			!loading &&
			(appointment.acu_points.length > 0 ||
				appointment.supplements.products.length > 0 ||
				appointment.formulas.products.length > 0 ||
				appointment.other_treatments.length > 0 ||
				appointment.custom_treatments.length > 0)
		"
	>
		<v-tabs class="text-caption" height="30" v-model="treatmentsTab">
			<v-tab
				class="text-caption"
				href="#plans"
				v-if="existPlans"
			>
				<v-icon small color="primary" class="mr-1">
					mdi-card-text-outline
				</v-icon>
				<translate>Treatment Plan</translate>
			</v-tab>
			<v-tab
				class="text-caption"
				v-if="acuPoints.length > 0"
				href="#acupuncture"
			>
				<v-icon small color="primary" class="mr-1"
					>$vuetify.icons.acuIcon</v-icon
				>
				<translate>Acupuncture</translate>
			</v-tab>
			<v-tab
				class="text-caption"
				v-if="auricularPoints.length > 0"
				href="#auricular-acupuncture"
			>
				<v-icon small color="primary" class="mr-1"
					>$vuetify.icons.acuIcon</v-icon
				>
				<translate>Auricular Acupuncture</translate>
			</v-tab>
			<v-tab
				class="text-caption"
				v-if="appointment.supplements.products.length > 0"
				href="#supplements"
			>
				<v-icon small color="primary" class="mr-1">mdi-pill</v-icon>
				<translate>Supplements</translate>
			</v-tab>
			<v-tab
				class="text-caption"
				v-if="appointment.formulas.products.length > 0"
				href="#cmm"
			>
				<v-icon small color="primary" class="mr-1"
					>$vuetify.icons.tcmIcon</v-icon
				>
				<translate>Chinese Materia Medica</translate>
			</v-tab>
			<v-tab
				class="text-caption"
				v-if="nutritionTreatment.length > 0"
				href="#nutrition"
			>
				<v-icon small color="primary" class="mr-1">mdi-food-apple</v-icon>
				<translate>Nutrition</translate>
			</v-tab>
			<v-tab class="text-caption" v-if="tuiNaTreatment.length > 0" href="#tui-na">
				<v-icon small color="primary" class="mr-1">mdi-hand-front-right</v-icon>
				Tui Na
			</v-tab>
			<v-tab class="text-caption" v-if="qiGongTreatment.length > 0" href="#qi-gong">
				<v-icon small color="primary" class="mr-1">mdi-yoga</v-icon>
				Qi Gong
			</v-tab>
			<v-tab class="text-caption" v-if="osteoTreatment.length > 0" href="#osteo">
				<v-icon small color="primary" class="mr-1">mdi-hand-front-right</v-icon>
				<translate>Osteopathy</translate>
			</v-tab>
			<v-tab
				v-for="customTreatment in customTreatments"
				:key="customTreatment.id"
				class="text-caption"
				:href="'#' + customTreatment.id + customTreatment.name"
			>
				<v-icon small color="primary" class="mr-1">mdi-clipboard-text</v-icon>
				{{ customTreatment.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="treatmentsTab">
			<v-tab-item :transition="false" :reverse-transition="false" value="plans" v-if="existPlans">
				<v-container fluid>
					<v-row no-gutters class="mt-3">
						<v-col v-if="appointment.tcm_treatment_plan" cols="12"><span v-translate class="font-weight-bold">TCM</span> - {{appointment.tcm_treatment_plan}}</v-col>
						<v-col v-if="appointment.supp_treatment_plan" cols="12"><span v-translate class="font-weight-bold">Fitotherapy</span> - {{appointment.supp_treatment_plan}}</v-col>
						<v-col v-if="appointment.nut_treatment_plan" cols="12"><span v-translate class="font-weight-bold">Nutrition</span> - {{appointment.nut_treatment_plan}}</v-col>
						<v-col v-if="appointment.osteo_treatment_plan" cols="12"><span v-translate class="font-weight-bold">Osteopathy</span> - {{appointment.osteo_treatment_plan}}</v-col>
					</v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="acuPoints.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="acupuncture"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.tcm_treatment_plan"
						@click="showTCMTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<span v-if="appointment.ashi_points && appointment.ashi_points != ''"
						><span class="font-weight-bold" v-translate>Ashi Points</span>:
						{{ appointment.ashi_points }}</span
					>
					<AcupunctureGrid
						:acuPoints="acuPoints"
						:edit="false"
						:auricular="false"
					/>
          <v-row v-if="importOption" no-gutters>
            <v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'acu')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Acupuncture</span>
						</v-btn>
          </v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="auricularPoints.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="auricular-acupuncture"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.tcm_treatment_plan"
						@click="showTCMTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<AcupunctureGrid
						:acuPoints="auricularPoints"
						:edit="false"
						:auricular="true"
					/>
          <v-row v-if="importOption" no-gutters>
            <v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'auricular')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Auricular Acupuncture</span>
						</v-btn>
          </v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="appointment.supplements.products.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="supplements"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.supp_treatment_plan"
						@click="showSupplementsTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<p class="text-body-2">
						<ProductItemHistory
							v-for="product in appointment.supplements.products"
							:key="product.product.id"
							:product="product"
							type="supplement"
						/>
					</p>
          <v-row v-if="importOption" no-gutters>
            <v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'supplements')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Supplements</span>
						</v-btn>
          </v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="appointment.formulas.products.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="cmm"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.tcm_treatment_plan"
						@click="showTCMTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<p class="text-body-2">
						<ProductItemHistory
							v-for="formula in appointment.formulas.products"
							:key="formula.product.id"
							:product="formula"
							type="formula"
						/>
					</p>
          <v-row v-if="importOption" no-gutters>
            <v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'mmc')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Chinese Materia Medica</span>
						</v-btn>
          </v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="nutritionTreatment.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="nutrition"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.nut_treatment_plan"
						@click="showNutritionTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<div
						v-html="t.id"
						class="text-body-2 text-treatment"
						v-for="t in nutritionTreatment"
						:key="t.id"
					></div>
          <v-row v-if="importOption" no-gutters>
            <v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'nut')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Nutrition</span>
						</v-btn>
          </v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="tuiNaTreatment.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="tui-na"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.tcm_treatment_plan"
						@click="showTCMTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<p
						v-html="t.id"
						class="text-body-2 text-treatment"
						v-for="t in tuiNaTreatment"
						:key="t.id"
					></p>
					<v-row v-if="importOption" no-gutters>
						<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'tn')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Tui Na</span>
						</v-btn>
					</v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="qiGongTreatment.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="qi-gong"
			>
				<v-container fluid>
					<v-btn
						small
						text
						icon
						v-if="appointment.tcm_treatment_plan"
						@click="showTCMTreatmentPlan = true"
					>
						<v-icon small>info_outline</v-icon>
					</v-btn>
					<div
						v-html="t.id"
						class="text-body-2 text-treatment"
						v-for="t in qiGongTreatment"
						:key="t.id"
					></div>
					<v-row v-if="importOption" no-gutters>
						<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'qg')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1">Qi Gong</span>
						</v-btn>
					</v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-if="osteoTreatment.length > 0"
				:transition="false"
				:reverse-transition="false"
				value="osteo"
			>
				<v-container fluid>
					<div
						v-html="t.id"
						class="text-body-2 text-treatment"
						v-for="t in osteoTreatment"
						:key="t.id"
					></div>
					<v-row v-if="importOption" no-gutters>
						<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, 'osteo')" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1" v-translate>Osteopathy</span>
						</v-btn>
					</v-row>
				</v-container>
			</v-tab-item>
			<v-tab-item
				v-for="customTreatment in customTreatments"
				:key="customTreatment.id"
				:transition="false"
				:reverse-transition="false"
				:value="customTreatment.id + customTreatment.name"
			>
				<v-container fluid>
					<div
						v-html="customTreatment.text"
						class="text-body-2 text-treatment"
					></div>
					<v-row v-if="importOption" no-gutters>
						<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-treatment', appointment.id, customTreatment.id)" :disabled="loadingImportTreatment">
							<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
							<translate>Import</translate><span class="ml-1">{{customTreatment.name}}</span>
						</v-btn>
					</v-row>
				</v-container>
			</v-tab-item>
		</v-tabs-items>
		<v-dialog
			v-if="appointment.tcm_treatment_plan"
			v-model="showTCMTreatmentPlan"
			max-width="65%"
		>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>TCM</translate>
					<span class="mx-2">-</span>
					<translate>Treatment Plan</translate>
				</v-card-title>
				<v-card-text>
					<v-row no-gutters class="mt-3">
						<v-col cols="12" sm="12">{{
							appointment.tcm_treatment_plan
						}}</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary darken-1"
						text
						@click="showTCMTreatmentPlan = false"
					>
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-if="appointment.supp_treatment_plan"
			v-model="showSupplementsTreatmentPlan"
			max-width="65%"
		>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Supplements</translate>
					<span class="mx-2">-</span>
					<translate>Treatment Plan</translate>
				</v-card-title>
				<v-card-text>
					<v-row no-gutters class="mt-3">
						<v-col cols="12" sm="12">{{
							appointment.supp_treatment_plan
						}}</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary darken-1"
						text
						@click="showSupplementsTreatmentPlan = false"
					>
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-if="appointment.nut_treatment_plan"
			v-model="showNutritionTreatmentPlan"
			max-width="65%"
		>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Nutrition</translate>
					<span class="mx-2">-</span>
					<translate>Treatment Plan</translate>
				</v-card-title>
				<v-card-text>
					<v-row no-gutters class="mt-3">
						<v-col cols="12" sm="12">{{
							appointment.nut_treatment_plan
						}}</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary darken-1"
						text
						@click="showNutritionTreatmentPlan = false"
					>
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
	<p v-else class="font-weight-thin ml-2" v-translate key="no-treatments">
		No treatments.
	</p>
</template>

<script>
import AcupunctureGrid from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGrid.vue";
import ProductItemHistory from "@/components/products/ProductItemHistory.vue";

export default {
  name: "ClinicHistoryTreatments",
  props: ["appointment", "loading", "importOption", "loadingImportTreatment"],
  components: {
    AcupunctureGrid,
    ProductItemHistory
  },
  data: () => ({
	treatmentsTab: null,
	showSupplementsTreatmentPlan: false,
	showTCMTreatmentPlan: false,
	showNutritionTreatmentPlan: false
  }),
  computed: {
	acuPoints() {
		return this.appointment.acu_points.filter(p => !p.auricular);
	},
	auricularPoints() {
		return this.appointment.acu_points.filter(p => p.auricular);
	},
	nutritionTreatment() {
		return this.appointment.other_treatments.filter(t => t.module === "nut");
	},
	tuiNaTreatment() {
		return this.appointment.other_treatments.filter(t => t.module === "tn");
	},
	qiGongTreatment() {
		return this.appointment.other_treatments.filter(t => t.module === "qg");
	},
	osteoTreatment() {
		return this.appointment.other_treatments.filter(t => t.module === "osteo");
	},
    customTreatments() {
		return this.appointment.custom_treatments;
	},
	existPlans() {
		if(this.appointment.tcm_treatment_plan || this.appointment.supp_treatment_plan || this.appointment.nut_treatment_plan) return true;
		else return false;
	}
  }
}
</script>